import { useCallback, useEffect, useState } from 'react'

import sessionStorage from '@/core/utils/storage/sessionStorage'
const BANNER_STORAGE_KEY = 'ecs-app-banner'

const useShowAppInstallBanner = () => {
  const { getItem, setItem } = sessionStorage
  const [showBanner, setShowBanner] = useState(false)

  const getBannerState = useCallback(() => {
    try {
      return getItem(BANNER_STORAGE_KEY)
    } catch {
      return false
    }
  }, [getItem])

  useEffect(() => {
    setShowBanner(!getBannerState())
  }, [getBannerState])

  const hideBanner = () => {
    setItem(BANNER_STORAGE_KEY, true)
    setShowBanner(false)
  }

  return {
    hideBanner,
    showBanner,
  }
}

export default useShowAppInstallBanner
